const i="wix-draft-plugin-file-upload";export{i as FILE_UPLOAD_TYPE};
//# sourceMappingURL=types.js.map
